import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Select from "react-select";
import { components } from "react-select";
import { CircularAvatar } from "../../commons";
import { SelctOptionType } from "../../DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import { CalenderIcon } from "../../Icon";

type AppProps = {
  isOpen: boolean;
  toggle: () => void;
  userSelected: SelctOptionType[] | [];
  loginData: LoginResponseType;
  setUserText: React.Dispatch<React.SetStateAction<string>>;
  setUserOffset: React.Dispatch<React.SetStateAction<number>>;
  handleSendEmailChangeChange: (e: any) => void;
  finalUserList: any;
  userLimit: number;
  authFetching: boolean;
  handleSubmitJobWithUserEmail: () => void;
  singleJobData: any;
  finalUserListData: any;
  selectedDropdownList: any;
  removeSelectedData: (data: number) => void;
};
const SendEmailRequestJob = ({
  isOpen,
  toggle,
  userSelected,
  loginData,
  setUserText,
  setUserOffset,
  handleSendEmailChangeChange,
  finalUserList,
  userLimit,
  authFetching,
  handleSubmitJobWithUserEmail,
  singleJobData,
  finalUserListData,
  selectedDropdownList,
  removeSelectedData,
}: AppProps) => {
  const [accessToOthersText, setAccessToOthersText] = useState<string>("");
  const checkBottom = (e:any) => {
    setUserOffset((prv: any) => prv + userLimit);
  };

  const openJobStatusStyle = () => {
    return {
      padding: "4px 14px",
      color: "#82b01f",
      background: "#e7f0d4",
      borderRadius: "16px",
      fontSize: "12px",
      fontWeight: "400",
    };
  };
  const closeJobStatusStyle = () => {
    return {
      padding: "4px 14px",
      color: "#6f7a90",
      background: "#f4f6f8",
      borderRadius: "16px",
      fontSize: "12px",
      fontWeight: "400",
    };
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label}
            image={data?.image && data?.image}
          />
          {data?.label}
        </div>
      </components.Option>
    );
  };
  return (
    <Modal
      backdrop="static"
      isOpen={isOpen}
      toggle={toggle}
      size="xl"
      style={{ width: "80%" }}
    >
      <ModalHeader toggle={toggle}>Send For Job Closure</ModalHeader>
      <ModalBody className="pl-4 pr-4 pt-4 pb-4">
        <p style={{ fontSize: "15px", fontWeight: "500", marginLeft: "15px" }}>
          Note:{" "}
          {`You’re requesting to close ${singleJobData?.job_id}_${
            singleJobData?.job_type ? singleJobData?.job_type : ""
          }_${singleJobData?.period_ended} to your Job Manager.`}
        </p>
        <div className="d-flex col-md-12 pl-0">
          <div className="col-md-6 pl-0">
            <div className="col-md-8 mb-2 mt-2">
              <label> Notify User</label>
              <Select
                className="dropdown"
                value={[{ label: "Select or Search User", value: null }]}
                options={finalUserListData}
                onChange={(e:any)=>handleSendEmailChangeChange(e)}
                components={{ Option }}
                isLoading={authFetching}
                isSearchable={true}
                onMenuScrollToBottom={(e: any) => checkBottom(e)}
                onInputChange={(e: string) => {
                  setUserText(e);
                }}
                onMenuClose={() => setUserOffset(0)}

                placeholder="Select or Search User"
              />
            </div>
            <div className="col-md-12" style={{ height: "45vh" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "2%",
                  maxHeight: "39vh",
                  overflow: "auto",
                  paddingBottom: "20px",
                }}
              >
                {!!selectedDropdownList?.length &&
                  selectedDropdownList?.map((data: any) => {
                    return (
                      <div
                        className="d-flex justify-content-between mt-2 p-1 w-100"
                        style={{
                          gap: "10px",
                          border: "1px solid #bfcbe1",
                          borderRadius: "6px",
                          alignItems: "center",
                        }}
                      >
                        <div className="d-flex">
                          <CircularAvatar
                            name={data?.label}
                            image={data?.image && data?.image}
                          />
                          <span className="ml-1">{data?.label}</span>
                        </div>
                        <span
                          id="cross-cut"
                          className="pointer"
                          style={{ right: "-4px" }}
                          onClick={() => removeSelectedData(data.value)}
                        >
                          X
                        </span>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="text-right d-flex">
              <button
                className="btn btn-primary ml-3"
                color="primary"
                onClick={() => {
                  handleSubmitJobWithUserEmail();
                }}
              >
                Submit
              </button>
            </div>
          </div>
          <div className="col-md-6 mb-3 p-0" style={{ height: "80%" }}>
            <div
              className="mt-2 p-0"
              style={{
                cursor: "pointer",
                border: "1px solid #bfcbe1",
                borderRadius: "8px",
              }}
            >
              <div className="list-header pl-3 pt-3">Jobs Summary</div>
              <hr style={{ borderColor: "#bfcbe1" }} />
              <div className="inside-card-header d-flex w-100 pt-1 pl-3">
                <span
                  style={{
                    color: "#6e7491",
                    fontSize: "13px",
                    fontWeight: "500",
                    width: "40%",
                  }}
                >
                  Job Type & ID
                </span>
                <span
                  style={{
                    width: "60%",
                    fontSize: "14px",
                    color: "#262a44",
                    fontWeight: "400",
                    paddingRight: "5px",
                    wordWrap: "break-word",
                  }}
                >{`${singleJobData?.job_id}_${singleJobData?.job_type}`}</span>
              </div>
              <div className="inside-card-header d-flex w-100 pt-3 pl-3">
                <span
                  style={{
                    color: "#6e7491",
                    fontSize: "13px",
                    fontWeight: "500",
                    width: "40%",
                  }}
                >
                  Client Details
                </span>
                <span
                  style={{
                    width: "60%",
                    fontSize: "14px",
                    color: "#262a44",
                    fontWeight: "400",
                    paddingRight: "5px",
                    wordWrap: "break-word",
                  }}
                >{`${singleJobData?.client_details?.company_name}(${singleJobData?.client_details?.client_code})`}</span>
              </div>
              <div className="inside-card-header d-flex w-100 pt-3 pl-3">
                <span
                  style={{
                    color: "#6e7491",
                    fontSize: "13px",
                    fontWeight: "500",
                    width: "40%",
                  }}
                >
                  Target End Date
                </span>
                {singleJobData?.target_end_date ? (
                  <div style={{ width: "60%", alignItems: "center" }}>
                    <span
                      className="calender-icon"
                      style={{
                        right: "12px",
                        top: "35px",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      <CalenderIcon />
                    </span>
                    <span
                      style={{
                        width: "60%",
                        fontSize: "14px",
                        paddingLeft: "3px",
                        color: "#262a44",
                        fontWeight: "400",
                      }}
                    >
                      {" "}
                      {singleJobData?.target_end_date}
                    </span>
                  </div>
                ) : (
                  <span
                    style={{
                      width: "60%",
                      fontSize: "14px",
                      color: "#262a44",
                      fontWeight: "400",
                    }}
                  >
                    --/--
                  </span>
                )}
              </div>
              <div className="inside-card-header d-flex w-100 pt-3 pl-3">
                <span
                  style={{
                    color: "#6e7491",
                    fontSize: "13px",
                    fontWeight: "500",
                    width: "40%",
                  }}
                >
                  Status
                </span>
                <span
                  style={
                    singleJobData?.job_status === "Open"
                      ? openJobStatusStyle()
                      : closeJobStatusStyle()
                  }
                >
                  {singleJobData?.job_status}
                </span>
              </div>
              <div
                className="inside-card-header d-flex w-100 pt-2 pl-3"
                style={{ alignItems: "center" }}
              >
                <span
                  style={{
                    color: "#6e7491",
                    fontSize: "13px",
                    fontWeight: "500",
                    width: "40%",
                  }}
                >
                  Currently Responsible
                </span>
                {singleJobData?.currently_responsible ? (
                  <div
                    className="d-flex "
                    style={{ width: "60%", alignItems: "center" }}
                  >
                    <CircularAvatar
                      name={`${singleJobData?.currently_responsible} `}
                      image={
                        singleJobData?.profile_pic &&
                        singleJobData?.profile_pic?.file_url
                      }
                    />
                    <span
                      style={{
                        paddingLeft: "5px",
                        fontSize: "15px",
                        color: "#262a44",
                        fontWeight: "400",
                      }}
                    >
                      {singleJobData?.currently_responsible}
                    </span>
                  </div>
                ) : (
                  <span
                    style={{
                      width: "60%",
                      fontSize: "14px",
                      color: "#262a44",
                      fontWeight: "400",
                    }}
                  >
                    --/--
                  </span>
                )}
              </div>
              <div
                className="inside-card-header d-flex w-100 pt-2 pl-3"
                style={{ alignItems: "center" }}
              >
                <span
                  style={{
                    color: "#6e7491",
                    fontSize: "13px",
                    fontWeight: "500",
                    width: "40%",
                  }}
                >
                  Job Manager
                </span>
                {singleJobData?.job_manager ? (
                  <div
                    className="d-flex "
                    style={{ width: "60%", alignItems: "center" }}
                  >
                    <CircularAvatar
                      name={`${singleJobData?.job_manager} `}
                      image={
                        singleJobData?.profile_pic &&
                        singleJobData?.profile_pic?.file_url
                      }
                    />
                    <span
                      style={{
                        paddingLeft: "5px",
                        fontSize: "15px",
                        color: "#262a44",
                        fontWeight: "400",
                      }}
                    >
                      {singleJobData?.job_manager}
                    </span>
                  </div>
                ) : (
                  <span
                    style={{
                      width: "60%",
                      fontSize: "14px",
                      color: "#262a44",
                      fontWeight: "400",
                    }}
                  >
                    --/--
                  </span>
                )}
              </div>

              <div className="inside-card-header d-flex w-100 pt-4 pl-3 pb-3">
                <span
                  style={{
                    color: "#6e7491",
                    fontSize: "13px",
                    fontWeight: "500",
                    width: "40%",
                  }}
                >
                  Job Summary
                </span>
                <span
                  style={{
                    width: "60%",
                    fontSize: "14px",
                    lineHeight: "23px",
                    color: "#262a44",
                    fontWeight: "400",
                    paddingRight: "8px",
                    wordWrap: "break-word",
                  }}
                >
                  {singleJobData?.job_description}
                </span>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter></ModalFooter>
    </Modal>
  );
};

export default SendEmailRequestJob;
